import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MFA_OAUTH_URL,
  MULTI_FACTOR_EndpointKey
} from '../../../../constants/login/login-remember-me-constant';
import { HttpRequestMethods, IDP_APP } from '../../../../constants/utils';
import {
  LoginAlternativeAuthentication,
  LoginAuthWithCredentialsResponse,
  OauthAEMConfig
} from '../../../../models/login';
import { HttpHeadersPayload, ReplaceItem } from '../../../../models/utils';
import { LoginRememberMeUtilsService } from '../../../../utils/login/login-remember-me-utils.service';
import { ApiBuilder } from '../../../utils/api-builder/api/api-builder';
import { AppConfigService } from '../../../utils/api-builder/config/app-config.service';
import { handleError } from '../../../utils/error/error.utils';

@Injectable({
  providedIn: 'root'
})
export class LoginAlternativeAuthenticationService {
  loginAlternativeAuthenticationHeader: HttpHeadersPayload = {
    'Content-Type':
      'application/vnd.pingidentity.useAlternativeAuthenticationSource+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private utils: LoginRememberMeUtilsService,
    private http: HttpClient,
    private appConfig: AppConfigService
  ) {}

  loginAlternativeAuthentication = (
    authConfig: OauthAEMConfig,
    flowIdValue: string
  ): Observable<LoginAuthWithCredentialsResponse> => {
    const getLoginAuthWithCredentialsUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const loginAuthWithCredentialsUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: getLoginAuthWithCredentialsUrl
      }
    ];

    const payload: LoginAlternativeAuthentication = {
      authenticationSource: 'Fly Delta App'
    };

    return new ApiBuilder<
      LoginAlternativeAuthentication,
      LoginAuthWithCredentialsResponse
    >(this.http, this.appConfig)
      .app(IDP_APP.COMMON)
      .endpointKey(MULTI_FACTOR_EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(loginAuthWithCredentialsUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.LOGIN_TIMEOUT ?? 10000)
      .payload(payload)
      .httpHeaders(this.loginAlternativeAuthenticationHeader)
      .errorHandler(this._errorHandler)
      .library('LOGIN_ALTERNATIVE_AUTHENTICATION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
